var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip"},[_c('sui-icon',{attrs:{"name":"send"},on:{"click":_vm.sendEmail}}),_c('span',{staticClass:"tooltiptext"},[_vm._v("Send notification")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }